// extracted by mini-css-extract-plugin
export var button = "Button-module--button--adebe";
export var faSpin = "Button-module--fa-spin--56c95";
export var fill = "Button-module--fill--32992";
export var iconGrid = "Button-module--iconGrid--1463d";
export var iconGridSmall = "Button-module--iconGridSmall--ecbe8";
export var inversed = "Button-module--inversed--527ca";
export var loading = "Button-module--loading--92e17";
export var plain = "Button-module--plain--2e9ad";
export var secondary = "Button-module--secondary--e5b50";
export var small = "Button-module--small--93dd7";